import { render, staticRenderFns } from "./HomePhones.vue?vue&type=template&id=3e9a2170&"
import script from "./HomePhones.vue?vue&type=script&lang=js&"
export * from "./HomePhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports